/**
 * Search API URL Constants
 * iOS SearchTab 기반 6개 탭 + 자동완성
 */

// ============================================================
// Display API (신규) - POST JSON Body
// ============================================================

/**
 * POST 통합 검색 (시술설명 탭)
 */
export const API_SEARCH_ALL = '/display/search-view/web/all'

/**
 * POST 이벤트 검색 (이벤트 탭)
 */
export const API_SEARCH_SERVICE_OFFERS = '/display/search-view/web/service-offers'

/**
 * POST 후기 검색 (시술후기 탭)
 */
export const API_SEARCH_REVIEWS = '/display/search-view/reviews'

/**
 * POST 자동완성
 */
export const API_SEARCH_AUTOCOMPLETES = '/display/search-view/autocompletes'

/**
 * POST 연관 검색어
 */
export const API_SEARCH_RELATED_QUERIES = '/display/search-view/related-queries'

/**
 * POST 연관 시술
 */
export const API_SEARCH_RELATED_TREATMENTS = '/display/search-view/related-treatments'

/**
 * POST 병원 검색 (병원 탭) - Display API (신규)
 * iOS에서 아직 미사용, OpenAPI 스펙에 존재
 * 검색 Sq.에서도 관리 안되고 있다고 이야기함. -> /search/hospitals 사용하기
 */
export const API_SEARCH_HOSPITALS_DISPLAY = '/display/search-view/hospitals'

// ============================================================
// Legacy API (구버전) - GET Query String
// ============================================================

/**
 * GET 병원 검색 (병원 탭) - Legacy
 */
export const API_SEARCH_HOSPITALS = '/search/hospitals'

/**
 * GET 커뮤니티/문서 검색 (커뮤니티 탭) - Legacy
 */
export const API_SEARCH_DOCUMENT = '/search/document'

/**
 * GET 의사 검색 (의사 탭) - Legacy
 */
export const API_SEARCH_DOCTOR = '/search/doctor'

// ============================================================
// Filter API
// ============================================================

/**
 * GET 지역 필터 (로그인 사용자)
 * 정적 데이터 - 검색어와 무관
 */
export const API_SEARCH_FILTER_DISTRICTS = '/search/filters/districts'

/**
 * GET 지역 필터 (비로그인 사용자)
 * 정적 데이터 - 검색어와 무관
 */
export const API_GUEST_SEARCH_FILTER_DISTRICTS = '/guest/search/filters/districts'

/**
 * POST 시술 필터
 * 동적 데이터 - 검색어에 따라 count 변경
 */
export const API_SEARCH_TREATMENT_FILTER = '/display/search-view/service-offer-treatment-filter'

/**
 * POST 가격 필터
 * 동적 데이터 - 검색어에 따라 범위 변경
 */
export const API_SEARCH_PRICE_FILTER = '/display/search-view/service-offer-price-filter'
